import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LiveSectionBoxComponent } from './live-section-box.component';
import { LiveVideoModule } from '../live-video/live-video.module';
import { SafePipeModule } from '../../pipes/safe/safe.module';

@NgModule({
    imports: [
        CommonModule,
        SafePipeModule,
        LiveVideoModule,
    ],
    exports: [ LiveSectionBoxComponent ],
    declarations: [ LiveSectionBoxComponent ],
    entryComponents: [ LiveSectionBoxComponent ],
})
export class LiveSectionBoxModule { }
